import { Splitter } from "@mcleod/components";
import { AutogenLayoutPlanningTitle } from "./autogen/AutogenLayoutPlanningTitle";

export class PlanningTitle extends AutogenLayoutPlanningTitle {
    private splitter: Splitter;
    private splitterPresetMin = "20%";
    private splitterPresetMid = "50%";
    private splitterPresetMax = "80%";

    public set majorTitle(value: string) {
        this.labelMajorTitle.text = value;
    }

    public set minorTitle(value: string) {
        this.labelMinorTitle.text = value;
    }

    attachToSplitter(splitter: Splitter) {
        this.splitter = splitter;
        this.splitter.addChangeListener(this.onSplitterChange);
        this.syncChevrons();
        this.panelSplitterControl.visible = true;
    }

    private onSplitterChange = () => {
        this.syncChevrons();
    };

    private syncChevrons() {
        this.syncChevronVisibility();
        this.syncChevronRotation();
    }

    private syncChevronVisibility() {
        const currentPosition = this.getPositionAsPercent();
        this.imageDoubleChevronLess.visible = currentPosition > 70;
        this.imageChevronLess.visible = currentPosition >= 30;
        this.imageChevronMore.visible = currentPosition <= 70;
        this.imageDoubleChevronMore.visible = currentPosition < 30;
    }

    private syncChevronRotation() {
        const doubleChevronRotation = this.splitter.isHorizontal() ? 0 : 90;
        this.imageDoubleChevronLess.rotation = doubleChevronRotation + 180;
        this.imageDoubleChevronMore.rotation = doubleChevronRotation;

        const chevronRotation = this.splitter.isHorizontal() ? 90 : 180;
        this.imageChevronLess.rotation = chevronRotation;
        this.imageChevronMore.rotation = chevronRotation + 180;
    }

    private getPositionAsPercent(): number {
        return Math.round(parseFloat(this.splitter.positionAsPercent));
    }

    imageDoubleChevronLessOnClick() {
        this.splitter.position = this.splitterPresetMin;
    }

    imageChevronLessOnClick() {
        const currentPosition = this.getPositionAsPercent();
        this.splitter.position = currentPosition <= 50 ? this.splitterPresetMin : this.splitterPresetMid;
    }

    imageChevronMoreOnClick() {
        const currentPosition = this.getPositionAsPercent();
        this.splitter.position = currentPosition >= 50 ? this.splitterPresetMax : this.splitterPresetMid;
    }

    imageDoubleChevronMoreOnClick() {
        this.splitter.position = this.splitterPresetMax;
    }
}
